import { useCallback, useEffect, useRef, useState } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import unescapedText from 'I18n/utils/unescapedText';
import { useGetSubscriptionsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';
import { paymentMethodFingerprint } from '../utils/paymentMethodFingerprint';
import { useAppDispatch } from '../redux';
import { clearPaymentMethodUpdate } from '../features/PaymentMethodUpdate/PaymentMethodUpdateSlice';
const POLL_INTERVAL_MS = 2000;
const POLL_TIMEOUT_MS = 30000;
export function usePollSubscriptionPaymentMethodUpdated({
  subscriptionId,
  previousMethod
}) {
  const dispatch = useAppDispatch();
  const [isPolling, setIsPolling] = useState(subscriptionId !== null);
  const resolvedRef = useRef(false);
  const {
    data
  } = useGetSubscriptionsQuery({
    skip: !subscriptionId || !isPolling,
    fetchPolicy: 'network-only',
    pollInterval: POLL_INTERVAL_MS
  });
  const success = useCallback(confirmed => {
    if (resolvedRef.current) return;
    resolvedRef.current = true;
    setIsPolling(false);
    if (confirmed) {
      FloatingAlertStore.addAlert({
        message: unescapedText('subscriptions.paymentMethodUpdated'),
        type: 'success'
      });
    }
    dispatch(clearPaymentMethodUpdate());
  }, [dispatch]);
  useEffect(() => {
    if (!subscriptionId) return;
    const timeoutId = setTimeout(() => success(false), POLL_TIMEOUT_MS);
    return () => clearTimeout(timeoutId);
  }, [subscriptionId, success]);
  useEffect(() => {
    var _data$results;
    if (!subscriptionId || !data || !previousMethod) return;
    const subscription = (_data$results = data.results) === null || _data$results === void 0 ? void 0 : _data$results.find(sub => sub.objectId === subscriptionId);
    if (!subscription) return;
    const currentMethod = paymentMethodFingerprint(subscription.paymentMethodDetails);
    if (currentMethod !== previousMethod) {
      success(true);
    }
  }, [subscriptionId, previousMethod, data, success]);
}